"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var black = "#000000";
var blue1 = "#060d4c";
var blue2 = "#0a146e";
var blue3 = "#002983";
var blue4 = "#003cbe";
var blue5 = "#00e1ff";
var blue6 = "#80f0ff";
var blue7 = "#c6f9ff";
var blue8 = "#f2fcff";
var green1 = "#235e00";
var green2 = "#338800";
var green3 = "#26ab2c";
var green4 = "#9bf01e";
var green5 = "#ccf78e";
var green6 = "#f3fce8";
var grey1 = "#141e37";
var grey2 = "#233750";
var grey3 = "#37506e";
var grey4 = "#8291af";
var grey5 = "#c8d2e6";
var grey6 = "#e6ebf5";
var grey7 = "#f0f5fa";
var orange1 = "#e86600";
var orange2 = "#ff7850";
var red1 = "#7c0017";
var red2 = "#b30021";
var red3 = "#fff6f8";
var white = "#ffffff";
var yellow1 = "#fffa00";
var yellow2 = "#fffc80";
var yellow3 = "#fffde8";
exports.default = {
  black: black,
  blue1: blue1,
  blue2: blue2,
  blue3: blue3,
  blue4: blue4,
  blue5: blue5,
  blue6: blue6,
  blue7: blue7,
  blue8: blue8,
  green1: green1,
  green2: green2,
  green3: green3,
  green4: green4,
  green5: green5,
  green6: green6,
  grey1: grey1,
  grey2: grey2,
  grey3: grey3,
  grey4: grey4,
  grey5: grey5,
  grey6: grey6,
  grey7: grey7,
  orange1: orange1,
  orange2: orange2,
  red1: red1,
  red2: red2,
  red3: red3,
  white: white,
  yellow1: yellow1,
  yellow2: yellow2,
  yellow3: yellow3
};